import type { FaireProductEntity } from "../../entity_types/product";

export const p_up99mrpkkk: FaireProductEntity = {
  token: "p_up99mrpkkk",
  type: "product",
  name: "Strawberry Vanilla",
  brandToken: "b_2ncsmapy03",
  brandName: "Olipop",
  imageUrl:
    "https://cdn.faire.com/fastly/17fc29ab8d4593a91602a869e2f996b087c1bbc5e2b4aa95a5d080cfa2d23585.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/80ed4eb915e2b2b50cddbd97473191ef45429db9307ca64ac51742197e0b8f2d.png",
    "https://cdn.faire.com/fastly/660fb20dc1b004801ef25162c94fdda954aabb141607f2182c2b6bc9e81e8ddd.png",
    "https://cdn.faire.com/fastly/1d2580662f7296abca88965ef6b55ff9a24f108eb8fb61f22365f873a0cb9bba.png",
    "https://cdn.faire.com/fastly/0b4a590b0ca96bf1c125a8b30a65ee6719e07f566c4ac2ea0bf69bef9a663969.png",
  ],
  priceDollars: 28.99,
  description:
    "Strawberry Vanilla is a modern take on a classic cream soda. We use real strawberry juice, fresh lemon and pink rock salt to round out what is a naturally sweet, refreshing treat.\n\nWholesale cost offers landed cost of $2.42 per unit, which provides a 40% gross margin to the retailer at $3.99 MSRP.",
  tags: [],
  msrpDollars: 57.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T17:24:06.244Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
